module.exports = __webpack_public_path__ + "static/bankomat-3ddfd2d0747e886a146e5b7be7a93df8.jpg";